export default function snakeToCamel(str) {
  return str.toLowerCase()
    .replace(/([-_][a-z])/g, (group) => group
      .toUpperCase()
      .replace('-', '')
      .replace('_', ''));
}
